import { render, staticRenderFns } from "./ms-lead-item.vue?vue&type=template&id=1e420178&scoped=true"
import script from "./ms-lead-item.vue?vue&type=script&lang=js"
export * from "./ms-lead-item.vue?vue&type=script&lang=js"
import style0 from "./ms-lead-item.vue?vue&type=style&index=0&id=1e420178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e420178",
  null
  
)

export default component.exports